import { createSlice } from "@reduxjs/toolkit";
import { convertDateObjToServerDate, getSameMonthLastYearEnd, getTwoMonthsBeforeLastMonthByDate } from "../../../../../utils/datetimeutil";

const lastMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
const twoMonthsBeforeLastMonth = getTwoMonthsBeforeLastMonthByDate(lastMonth);
const lastYear = getSameMonthLastYearEnd(lastMonth);

const companiesLogSlice = createSlice({
  name: "company-log",
  initialState: {
    start_month: convertDateObjToServerDate(twoMonthsBeforeLastMonth, true),
    end_month: convertDateObjToServerDate(lastMonth, true),
    baseCode: null,
    last_year: convertDateObjToServerDate(lastYear, true)
  },
  reducers: {
    clearState(state) {
      state.start_month = convertDateObjToServerDate(twoMonthsBeforeLastMonth, true);
      state.end_month = convertDateObjToServerDate(lastMonth, true);
      state.baseCode = null;
    },
    setStartMonth(state, action) {
      state.start_month = action.payload;
    },
    setEndMonth(state, action) {
      state.end_month = action.payload;
    },
    setLastYear(state, action) {
      state.last_year = action.payload;
    },
    setLocation(state, action) {
      state.baseCode = action.payload;
    }
  }
});

export const {
  clearState: clearCompanyLogState,
  setStartMonth: setCompanyLogStartMonth,
  setEndMonth: setCompanyLogEndMonth,
  setLocation: setCompanyLogLocation,
  setLastYear: setCompanyLogLastYear
} = companiesLogSlice.actions;

export default companiesLogSlice.reducer;
